import { render, staticRenderFns } from "./NotificationsModal.vue?vue&type=template&id=01b1ce90"
import script from "./NotificationsModal.vue?vue&type=script&lang=ts"
export * from "./NotificationsModal.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsModal.vue?vue&type=style&index=0&id=01b1ce90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports